// ============================================================
// RoleForm
// ------------------------------------------------------------
// ฟอร์มบทบาทผู้ใช้ (ชื่อบทบาท + รายละเอียด + ตารางติ๊กสิทธิ์ + ปุ่มท้ายจอ)
// ใช้ร่วมกันระหว่างหน้าเพิ่มบทบาทและหน้าแก้ไขบทบาท — เดิม 2 หน้านี้เขียน JSX ชุดนี้ซ้ำกัน
//
// props
//   title        : หัวข้อหน้าจอ
//   submitLabel  : ข้อความบนปุ่มบันทึก
//   role_name / role_description / role_detail : ค่าในฟอร์ม
//   onChange     : (patch) => void  — ส่ง object ที่จะ setState กลับไป
//   onSubmit     : กดปุ่มบันทึก
// ============================================================

import React from "react";

import { required } from "../core/validate.js";
import { PERMS, ROLE_COLUMNS, toggleRolePermission } from "../domain/role.js";
import { ICON } from "./icons.js";
import "../config/global.js";

export default function RoleForm({ title, submitLabel, role_name, role_description, role_detail, onChange, onSubmit }) {
  // ติ๊กทั้งคอลัมน์
  const toggleColumn = (columnId, checked) => onChange({ role_detail: toggleRolePermission(role_detail, columnId, checked) });
  // ติ๊กช่องเดียวในแถว
  const toggleCell = (columnId, index) => onChange({ role_detail: toggleRolePermission(role_detail, columnId, null, index) });

  // หัวคอลัมน์ติ๊กแล้วหรือยัง — ติ๊กเมื่อทุกแถวที่มีสิทธิ์ถูกติ๊กครบ
  const isColumnChecked = (columnId) => !role_detail.some((e) => e.permission && !e.hidden && (columnId === "all" ? PERMS.some((p) => !e.permission[p]) : !e.permission[columnId]));

  // ช่องในแถวติ๊กแล้วหรือยัง
  const isCellChecked = (item, columnId) => (columnId === "all" ? PERMS.every((p) => item.permission[p]) : item.permission[columnId]);

  return (
    <>
      <div className="body mb-4 pb-4">
        <div className="row">
          <div className="col-12 col-md-10 col-xl-8 p-3 mx-auto">
            <div className="w-100 d-flex align-items-center justify-content-between px-3 mt-5">
              <h4 className="w-100">
                <b>{title}</b>
              </h4>
            </div>

            {/* ชื่อบทบาท + รายละเอียด */}
            <div className="w-100 p-3">
              <div className="card rounded">
                <div className="card-body">
                  <div className="d-flex mx-0 align-items-center mb-3">
                    <span className="wpx-100">ชื่อบทบาท{required}:</span>
                    <input type="text" className="form-control validate" placeholder="กรอกข้อมูล" value={role_name} onChange={(e) => onChange({ role_name: e.target.value })} />
                  </div>
                  <div className="d-flex mx-0 align-items-start">
                    <span className="wpx-100 mt-1">รายละเอียด:</span>
                    <textarea className="form-control validate" placeholder="กรอกข้อมูล" rows={5} value={role_description} onChange={(e) => onChange({ role_description: e.target.value })} />
                  </div>
                </div>
              </div>
            </div>

            {/* ตารางสิทธิ์ — แถวที่ permission เป็น null คือหัวข้อกลุ่มเมนู ติ๊กไม่ได้ */}
            <div className="w-100 p-3" style={{ marginBottom: 100 }}>
              <div className="card rounded">
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-borderless">
                      <thead>
                        <tr className="bg-dark-blue text-white">
                          <th className="text-left">เมนูจัดการ</th>
                          {ROLE_COLUMNS.map((column) => (
                            <th key={column.id} className="text-center text-nowrap">
                              {column.name} <br />
                              <input className="mt-2" type="checkbox" checked={isColumnChecked(column.id)} onChange={(e) => toggleColumn(column.id, e.target.checked)} />
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {/* แถว hidden = เมนูที่ไม่มีในตารางนี้แต่ต้องเก็บค่าไว้ (ดู fromApiRoleDetail) */}
                        {role_detail.map((item, i) =>
                          item.hidden ? null : (
                          <tr key={i} className={item.permission ? "" : "bg-contain"}>
                            <td className="text-nowrap">{global.roleth[item.menu_name]}</td>
                            {ROLE_COLUMNS.map((column) => (
                              <td key={column.id} className="text-center">
                                {item.permission && <input type="checkbox" checked={isCellChecked(item, column.id)} onChange={() => toggleCell(column.id, i)} />}
                              </td>
                            ))}
                          </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* แถบปุ่มติดล่างจอ */}
      <div className="body px-3 pt-3 bg-white position-fixed" style={{ bottom: 0 }}>
        <div className="row mx-0">
          <div className="ml-auto col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3">
            <button type="button" className="btn btn-outline-primary wpx-150 px-4" onClick={() => (window.location.href = "/role")}>
              <span className="icon-brand mr-2">{ICON.back}</span>ย้อนกลับ
            </button>
          </div>
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 px-2 mb-3">
            <button className="btn btn-primary w-100" onClick={onSubmit}>
              {submitLabel}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
